import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getlanguagelist } from "../../helpers/changelanguage";
import StaticFooter from "./footer";
import StaticHeader from "./header";
import FooterLink from "./footerlink";

class ContactUs extends Component {

   componentDidMount(){
    
    document.querySelector('body').classList.remove('login_page');
    document.body.style.backgroundImage = "url('')";
   }

    backButton() {
      window.history.back();
    }
    render() {
      let  languagelist = getlanguagelist();
      return (
       
        <div className="static-page">    
        <StaticHeader />
            <section className="terms_conditions">
                <h2 className="text-center">{languagelist.Contact1}</h2>
                <div className="container">
                    <form id="contactForm" method="POST" action="https://api.baaldahab.com/welcome/save_contact">
                    <div className="row">
           
                        <div className="col-lg-6 col-sm-6">
                        
                                <div className="form-group">
                                <label for="sel1">{languagelist.Contact2}</label>
                                <select name="type" className="form-control" id="type" required>
                                <option></option>
                                <option>{languagelist.Contact7}</option>
                                <option>{languagelist.Contact8}</option>
                                <option>{languagelist.Contact9}</option>
                                <option>{languagelist.Contact10}</option>
                                </select>
                            </div> 
                            
                                <div className="form-group">
                                    <label for="email">{languagelist.Contact4}</label>
                                    <input type="text"  name="name" className="form-control" id="name" required />
                                </div>
                                
                                <div className="form-group">
                                    <label for="email">{languagelist.Contact6}</label>
                                    <input type="text" name="contact" className="form-control" id="contact" required />
                                </div>
                        
                        
                        
                        </div>
                        <div className="col-lg-6 col-sm-6">
                        
                            <div className="form-group">
                                <label for="email">{languagelist.Contact3}</label>
                                <input type="email" name="email" className="form-control" id="email" required/>
                            </div>
                            
                            <div className="form-group">
                                <label for="comment">{languagelist.Contact5}</label>
                                <textarea className="form-control" rows="5" name="message" id="message" required></textarea>
                            </div>
                            <div className="form-group">
                                <div  id="html_element"></div>
                            </div>
                        
                        </div>
         
                    </div>
                    <input type="hidden" name="language" className="form-control" id="language" value="en"/>
         
                    <div className="slide_text1">
                    
                        <button type="submit" id="contactSubmit" className="btn_1 hidden">Submit</button>
                    </div>
                    </form>
                </div>

            </section>
            <section className="panel_7 text-center">
                <div className="container">
                    <FooterLink />

                    <p> {languagelist.Staticfooter1}</p>
                </div>
            </section>

        <StaticFooter />

        </div>
      
      );
    }
  }
export default ContactUs;